import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getFoliosById, updateFolios} from '../../services/Configs/ItemFolios'

function EditItemFolioModal({ FolioId, show, handleClose, handleReload }) {
  const [formData, setFormData] = useState({
    id: 0,
    FolioName: '',
    isActive: false
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUpdateFolios = () => {
    let pendingInputs = [];

    if (!formData.FolioName) {
      pendingInputs.push("Folio")
    }

    if (pendingInputs.length == 0) {
      updateFolios(formData.id, formData.FolioName, formData.isActive).then(locationResult => {
        toast.success('Folio actualizado correctamente');
        handleClose();
        handleReload();
      });
    }
    else {
      toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }

  useEffect(() => {
    if (show) {
      getFoliosById(FolioId).then(obj => {
        setFormData({
          id: obj.id,
          FolioName: obj.name,
          isActive: obj.isActive
        });
      })
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar folio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Numero:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="FolioName"
                placeholder='Numero de folio'
                value={formData.FolioName}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <Form.Group className='mt-3' controlId="formWorkFromHome">
              <Form.Label>Estado:</Form.Label>
              <Form.Check
                type="radio"
                label="Activa"
                name="isActive"
                value="true"
                checked={formData.isActive === true}
                onChange={() => setFormData({ ...formData, isActive: true })}
              />
              <Form.Check
                type="radio"
                label="Inactiva"
                name="isActive"
                value="false"
                checked={formData.isActive === false}
                onChange={() => setFormData({ ...formData, isActive: false })}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleUpdateFolios}>
          Actualizar folio
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditItemFolioModal;